"use client";

import { useState } from "react";
import useCartStore from "../../store/cartStore";
import Logo from "../../assets/images/enedem.png";
import {
    Dialog,
    DialogPanel,
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    Popover,
    PopoverButton,
    PopoverGroup,
    PopoverPanel,
} from "@headlessui/react";
import {
    Bars3Icon,
    XMarkIcon,
    ShoppingCartIcon,
} from "@heroicons/react/24/outline";
import { ChevronDownIcon } from "@heroicons/react/20/solid";

import { ReactComponent as ContactMailIcon } from "../../assets/images/header/contact-mail.svg";
import { ReactComponent as DeliveryManIcon } from "../../assets/images/header/delivery-man.svg";
import { ReactComponent as FastDeliveryIcon } from "../../assets/images/header/fast-delivery.svg";
import { ReactComponent as LunchTimeIcon } from "../../assets/images/header/lunch-time.svg";
import { ReactComponent as ReservedIcon } from "../../assets/images/header/reserved.svg";
import { ReactComponent as RestaurantIcon } from "../../assets/images/header/restaurant.svg";
import { ReactComponent as WineGlassIcon } from "../../assets/images/header/wine-glass.svg";

const products = [
    {
        name: "Mittagskarte",
        description:
            "Unsere Mittagskarte bietet Ihnen eine Auswahl an Gerichten, die Dienstag bis Freitag von 11:30 Uhr bis 14:00 Uhr angeboten werden.",
        href: "/karte?Mittagskarte",
        icon: LunchTimeIcon,
    },
    {
        name: "Speisekarte",
        description:
            "Unsere Speisekarte beinhaltet alle Gerichte, die wir abends, am Wochenende und an Feiertagen servieren. Alle unsere Speisen werden frisch für Sie zubereitet.",
        href: "/karte?Speisekarte",
        icon: RestaurantIcon,
    },
    {
        name: "Weinkarte",
        description:
            "Alle Weine, die wir anbieten, sind sorgfältig selektiert und stammen von ausgewählten Winzern.",
        href: "/karte?Weinkarte",
        icon: WineGlassIcon,
    },
    {
        name: "Bestellkarte",
        description:
            "Unsere Bestellkarte bietet Ihnen eine Auswahl an Gerichten, die Sie bequem online zum Liefern oder Abholen bestellen können.",
        href: "/bestellen",
        icon: DeliveryManIcon,
    },
];
const callsToAction = [
    { name: "Kontaktanfrage", href: "/#kontaktanfrage", icon: ContactMailIcon },
    { name: "Reservierung tätigen", href: "/reservierung", icon: ReservedIcon },
    {
        name: "Bestellen und liefern lassen",
        href: "/bestellen",
        icon: FastDeliveryIcon,
    },
];

export default function Example() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const totalItems = useCartStore((state) => state.totalItems());
    const totalPrice = useCartStore((state) => state.totalPrice());

    return (
        <header className={"sticky w-full top-0 isolate bg-white z-50"}>
            <nav
                aria-label="Global"
                className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8"
            >
                <div className="flex lg:flex-1">
                    <a href="/" className="-m-1.5 p-1.5">
                        <span className="sr-only">En Edem</span>
                        <img alt="" src={Logo} className="h-4 md:h-8 w-auto" />
                    </a>
                </div>

                <PopoverGroup className="hidden lg:flex lg:gap-x-12">
                    <Popover>
                        <PopoverButton className="flex items-center gap-x-1 text-sm/6 font-semibold text-gray-900">
                            Speisekarten
                            <ChevronDownIcon
                                aria-hidden="true"
                                className="size-5 flex-none text-gray-400"
                            />
                        </PopoverButton>

                        <PopoverPanel
                            transition
                            className="absolute inset-x-0 top-0 -z-10 bg-white pt-14 shadow-lg ring-1 ring-gray-900/5 transition data-[closed]:-translate-y-1 data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in"
                        >
                            <div className="mx-auto grid max-w-7xl grid-cols-4 gap-x-4 px-6 py-10 lg:px-8 xl:gap-x-8">
                                {products.map((item) => (
                                    <div
                                        key={item.name}
                                        className="group relative rounded-lg p-6 text-sm/6 hover:bg-gray-50"
                                    >
                                        <div className="flex size-11 items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                                            <item.icon
                                                aria-hidden="true"
                                                className="size-10 text-gray-600 group-hover:text-indigo-600"
                                            />
                                        </div>
                                        <a
                                            href={item.href}
                                            className="mt-6 block font-semibold text-gray-900"
                                        >
                                            {item.name}
                                            <span className="absolute inset-0" />
                                        </a>
                                        <p className="mt-1 text-gray-600">
                                            {item.description}
                                        </p>
                                    </div>
                                ))}
                            </div>
                            <div className="bg-gray-50">
                                <div className="mx-auto max-w-7xl px-6 lg:px-8">
                                    <div className="grid grid-cols-3 divide-x divide-gray-900/5 border-x border-gray-900/5">
                                        {callsToAction.map((item) => (
                                            <a
                                                key={item.name}
                                                href={item.href}
                                                className="flex items-center justify-center gap-x-2.5 p-3 text-sm/6 font-semibold text-gray-900 hover:bg-gray-100"
                                            >
                                                <item.icon
                                                    aria-hidden="true"
                                                    className="size-8 flex-none text-gray-400"
                                                />
                                                {item.name}
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </PopoverPanel>
                    </Popover>

                    <a
                        href="/bestellen"
                        className="text-sm/6 font-semibold text-gray-900"
                    >
                        Bestellen
                    </a>
                    <a
                        href="/reservierung"
                        className="text-sm/6 font-semibold text-gray-900"
                    >
                        Reservieren
                    </a>
                    <a
                        target="_self"
                        className="text-sm/6 font-semibold text-gray-900 hover:cursor-pointer"
                        onClick={() => {
                            //Scroll into view to /#kontaktanfrage smoothly
                            document.location.href = "/#kontaktanfrage";
                        }}
                    >
                        Kontakt
                    </a>
                </PopoverGroup>
                {/* Shopping Cart */}
                <div
                    className="flex flex-1 lg:justify-end justify-center hover:cursor-pointer"
                    onClick={() => (window.location.href = "/checkout")}
                >
                    <div className="flex items-center gap-x-4">
                        <ShoppingCartIcon
                            className="h-6 w-6 text-gray-900"
                            aria-hidden="true"
                        />
                        <span className="text-sm font-semibold text-gray-900">
                            {totalItems} - {totalPrice.toFixed(2)}€
                        </span>
                    </div>
                </div>
                <div className="flex lg:hidden">
                    <button
                        type="button"
                        onClick={() => setMobileMenuOpen(true)}
                        className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
                    >
                        <span className="sr-only">Hauptmenü</span>
                        <Bars3Icon aria-hidden="true" className="size-6" />
                    </button>
                </div>
            </nav>
            <Dialog
                open={mobileMenuOpen}
                onClose={setMobileMenuOpen}
                className="lg:hidden"
            >
                <div className="fixed inset-0 z-10" />
                <DialogPanel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
                    <div className="flex items-center justify-between">
                        <a href="#" className="-m-1.5 p-1.5">
                            <span className="sr-only">Your Company</span>
                            <img
                                alt=""
                                src="https://tailwindui.com/plus/img/logos/mark.svg?color=indigo&shade=600"
                                className="h-8 w-auto"
                            />
                        </a>
                        <button
                            type="button"
                            onClick={() => setMobileMenuOpen(false)}
                            className="-m-2.5 rounded-md p-2.5 text-gray-700"
                        >
                            <span className="sr-only">Close menu</span>
                            <XMarkIcon aria-hidden="true" className="size-6" />
                        </button>
                    </div>
                    <div className="mt-6 flow-root">
                        <div className="-my-6 divide-y divide-gray-500/10">
                            <div className="space-y-2 py-6">
                                <Disclosure as="div" className="-mx-3">
                                    <DisclosureButton className="group flex w-full items-center justify-between rounded-lg py-2 pl-3 pr-3.5 text-base/7 font-semibold text-gray-900 hover:bg-gray-50">
                                        Speisekarten
                                        <ChevronDownIcon
                                            aria-hidden="true"
                                            className="size-5 flex-none group-data-[open]:rotate-180"
                                        />
                                    </DisclosureButton>
                                    <DisclosurePanel className="mt-2 space-y-2">
                                        {[...products].map((item) => (
                                            <DisclosureButton
                                                key={item.name}
                                                as="a"
                                                href={item.href}
                                                className="block rounded-lg py-2 pl-6 pr-3 text-sm/7 font-semibold text-gray-900 hover:bg-gray-50"
                                            >
                                                {item.name}
                                            </DisclosureButton>
                                        ))}
                                    </DisclosurePanel>
                                </Disclosure>
                                <a
                                    href="/bestellen"
                                    className="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                                >
                                    Bestellen
                                </a>
                                <a
                                    href="/reservierung"
                                    className="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                                >
                                    Reservieren
                                </a>
                                <a
                                    onClick={() => {
                                        setMobileMenuOpen(false);
                                        //Scroll into view to /#kontaktanfrage smoothly
                                        document.location.href =
                                            "/#kontaktanfrage";
                                    }}
                                    className="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                                >
                                    Kontakt
                                </a>
                            </div>
                        </div>
                    </div>
                </DialogPanel>
            </Dialog>
        </header>
    );
}
